import React, { useState, useEffect } from "react";
import { Layout, Menu, Dropdown } from "antd";
import {
  TableOutlined,
  BarChartOutlined,
  FileTextOutlined,
  ProfileOutlined,
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  UserOutlined,
  LogoutOutlined,
  UploadOutlined,
  OpenAIOutlined,
} from "@ant-design/icons";
import { Switch, Route, Redirect, useHistory } from "react-router-dom";
import dashboard from "../../assets/images/dashboard.svg";
import logo from "../../assets/images/logo.jpg";
import miniLogo from "../../assets/images/miniLogo.png";
import "./index.scss";
import { isPC, getUserInfo } from "../../utils";
import AccountDetails from "./AccountDetails";
import AccountOverview from "./AccountOverview";
import Admin from "./Admin";
import EventLogs from "./EventLogs";
import ModelPerformance from "./ModelPerformance";
import TouchstoneSubmissions from "./TouchstoneSubmissions";
import TouchstoneTasks from "./TouchstoneTasks";

const Main = ({ signOut }) => {
  const { Header, Sider, Content } = Layout;
  const history = useHistory();

  const [currentPage, setCurrentPage] = useState("accountOverview");
  const [collapsed, setCollapsed] = useState(!isPC());
  const [userInfo, setUserInfo] = useState();

  useEffect(() => {
    (async () => {
      const user = await getUserInfo();
      if (user === undefined) {
        return; // wait for userInfo
      }
      setUserInfo(user);
      if (user === null) {
        if (history.location.pathname !== "/") {
          history.push("/");
        }
      } else {
        history.location.pathname.split("/")[2] && setCurrentPage(history.location.pathname.split("/")[2]);
      }
    })();
  }, [history]);

  const handleClick = (e) => {
    setCurrentPage(e.key);
    history.push(`/main/${e.key}`);
  };

  if (!userInfo) return null; // wait for effect to run
  const cognitoGroups = userInfo.groups;
  const isElAdminUser = cognitoGroups.includes("el_admin_user");
  const isTouchstoneUser = cognitoGroups.includes("touchstone_user");
  const isTouchstoneAdmin = cognitoGroups.includes("touchstone_admin");
  const isSuperAdmin = cognitoGroups.includes("el_admin_super_admin");

  const menuItems = [];

  if (isElAdminUser) {
    menuItems.push(
      {
        label: "Account Overview",
        key: "accountOverview",
        icon: <TableOutlined />,
      },
      {
        label: "Model Performance",
        key: "modelPerformance",
        icon: <img width="15.5" src={dashboard} alt="" />,
      }
    );

    if (isSuperAdmin) {
      menuItems.push({
        label: "Admin",
        key: "Admin",
        icon: <ProfileOutlined />,
      });
    }

    menuItems.push(
      {
        label: "Account Details",
        key: "AccountDetails",
        icon: <BarChartOutlined />,
      },
      {
        label: "Event Logs",
        key: "eventLogs",
        icon: <FileTextOutlined />,
      }
    );
  }

  if (isTouchstoneUser || isTouchstoneAdmin) {
    menuItems.push({
      label: "Touchstone System",
      key: "touchstoneSubmissions",
      icon: <UploadOutlined />,
    });
  }

  if (isTouchstoneAdmin) {
    menuItems.push({
      label: "Touchstone Tasks",
      key: "touchstoneTasks",
      icon: <OpenAIOutlined />,
    });
  }

  const dropdownItems = [
    // TODO: 一期不做修改密码
    // {
    //   key: "changePsw",
    //   icon=(
    //     <EditOutlined />
    //   ),
    //   onClick: () => setIsOpenChangePwd(true),
    //   label: "Change Password",
    // },
    // <Menu.Divider />
    {
      key: "logout",
      icon: <LogoutOutlined />,
      onClick: async () => {
        await signOut({ global: true });
        history.push("/");
      },
      label: "Log Out",
    },
  ];

  return (
    <Layout style={{ minHeight: "100vh", overflow: "hidden" }}>
      <Sider breakpoint="lg" trigger={null} collapsedWidth={isPC() ? 80 : 0} collapsible collapsed={collapsed}>
        <div className={collapsed ? "center logo" : "logo"}>
          {collapsed ? <img src={miniLogo} height="32" alt="" /> : <img src={logo} height="32" alt="" />}
        </div>
        <Menu mode="inline" theme="dark" onClick={handleClick} selectedKeys={[currentPage]} items={menuItems} />
      </Sider>

      <Layout className="main">
        <Header className="site-layout-background" style={{ padding: 0 }}>
          {React.createElement(collapsed ? MenuUnfoldOutlined : MenuFoldOutlined, {
            className: "trigger",
            onClick: () => setCollapsed(!collapsed),
          })}
          {!(!isPC() && !collapsed) && (
            <div className="right-menu">
              {/* {locale === "EN" ? <Button>中文</Button> : <Button>English</Button>} */}
              <Dropdown menu={{ items: dropdownItems }}>
                <div>
                  <UserOutlined style={{ fontSize: 20, margin: "0 5px 0 20px" }} />
                  {userInfo.username}
                </div>
              </Dropdown>
            </div>
          )}
        </Header>
        <Content
          className="site-layout-background"
          style={{
            margin: "24px 16px",
            padding: 24,
            minHeight: 280,
            overflow: "auto",
            background: "#f0f2f5",
          }}
        >
          <div style={{ width: isPC() ? "auto" : "fit-content", minWidth: 1600 }}>
            <Switch>
              <Route
                path="/main/accountOverview"
                render={(props) => <AccountOverview {...props} setSideBarPage={setCurrentPage} />}
              ></Route>
              <Route path="/main/modelPerformance" exact component={ModelPerformance}></Route>
              <Route path="/main/admin" exact component={Admin}></Route>
              <Route path="/main/accountDetails" exact component={AccountDetails}></Route>
              <Route path="/main/accountDetails/:instrumentSymbol" exact component={AccountDetails}></Route>
              <Route path="/main/eventLogs" exact component={EventLogs}></Route>
              <Route path="/main/touchstoneSubmissions" exact component={TouchstoneSubmissions}></Route>
              <Route path="/main/touchstoneTasks" exact component={TouchstoneTasks}></Route>
              <Redirect to="/main/accountOverview"></Redirect>
            </Switch>
          </div>
        </Content>
      </Layout>
    </Layout>
  );
};
export default Main;
